module.exports = __webpack_public_path__ + "static/media/tire_logo.bfbe96b2.png";